import type { SlackConnectSettingsType } from "@productlane/zero/types"

export const DEFAULT_GROUPING = "SINGLE:30"

/** Each value is either a standalone SlackConnectSettings.type, or SINGLE plus its window. */
export const GROUPING_OPTIONS = [
	{ value: "MANUAL", label: "Off, manual push only" },
	{ value: "AUTOMATIC", label: "One per message" },
	{ value: DEFAULT_GROUPING, label: "30 minutes" },
	{ value: "SINGLE:60", label: "1 hour" },
	{ value: "SINGLE:1440", label: "24 hours" },
]

export function groupingValue(
	settings?: { type: string; groupingWindowMinutes: number } | null,
): string {
	if (!settings) return DEFAULT_GROUPING
	const value =
		settings.type === "SINGLE"
			? `SINGLE:${settings.groupingWindowMinutes}`
			: settings.type

	return GROUPING_OPTIONS.some((o) => o.value === value)
		? value
		: DEFAULT_GROUPING
}

export function parseGroupingValue(value: string): {
	type: SlackConnectSettingsType
	groupingWindowMinutes: number
} {
	const [type, window] = value.split(":")

	return {
		type: (type as SlackConnectSettingsType | undefined) ?? "SINGLE",
		groupingWindowMinutes: window ? Number(window) : 30,
	}
}
